import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import { environment } from "environments/environment";

Sentry.init({
  dsn: "https://9b374b2abf915461f19c60f5bb0b7cad@o941297.ingest.us.sentry.io/4508215428055040",
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],

  debug: false,
  environment: process.env.NODE_ENV,
  release: process.env.REACT_APP_SENTRY_RELEASE,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: 0.5,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/defectwise-api-apim\.azure-api\.net/, /^https:\/\/server\.defectwise\.com\.au/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // reducing to only capture errors as keep going over limit
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: environment.production ? 1.0 : 0,
});
